import { Tabs } from 'antd';
import BaseInfo from '&/components/BaseInfo';
import ChangePassword from '&/components/ChangePassword';
import './AccountInfo.scss';
// import BasePageWrap from '&/components/ResourceLib/BasePageWrap'
// import '&/components/ResourceLib/BasePageWrap.scss'
const { TabPane } = Tabs;

export default function AccountInfo() {
    return (
        <div
            type="card"
            className="base-card-page card basic-info  full-content"
            title={intl.get('accountSetting.personalInfo')}>
            <div className="content">
                <Tabs defaultActiveKey="1" tabBarGutter={0}>
                    <TabPane tab="个人信息" key="1">
                        <BaseInfo isBusiness />
                    </TabPane>
                    <TabPane tab="修改密码" key="2">
                        <ChangePassword />
                    </TabPane>
                </Tabs>
            </div>
        </div>
    );
}
